export default "__VITE_ASSET__mbnjDaM8__"